import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlay } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { useGetUser } from '../../../hooks/useGetUser';
import {
  Select,
  MenuItem,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  createMuiTheme,
  MuiThemeProvider,
  Checkbox,
  Button,
  FormGroup,
} from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment/locale/pt-br';
import FormData from 'form-data';
import styles from './styles.module.scss';
import ButtonsImagesCampain from '../../../components/ButtonsImagesCampain';
import ButtonsAnexoTreinamento from '../../../components/ButtonsAnexoTreinamento';
import Paginacao from '../../../components/Paginacao';
import {
  getParceiros,
  getRegional,
  getFilial,
  saveTreinamento,
  getTreinamentoWithId,
  postEncerrarCampanha,
  editTreinamento,
  contatosFinalizados,
  getListaParceirosTreinamento,
  getListaPerguntasTreinamento,
  getParceiroLogImportacao,
  postParceirosImportacaoExcel,
} from '../../../services/api-auto';
import ParceiroCard from '../../../components/ParceiroCard';
import PerguntaCard from '../../../components/PerguntaCard';
import modeloParticipanteCampanha from '../../../assets/docs/modeloParticipanteCampanha.xlsx';
import Paticipantes from '../../../views/AdicionarCampanha/ModalImportacao';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import { useDispatch } from 'react-redux';
import {
  showMsgW as showMsgWAction,
  showMsgE as showMsgEAction,
  showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';
import { useDebounce } from '../../../hooks/debounceHook';
import { faDownload, faSpinner } from '@fortawesome/free-solid-svg-icons';

import ModalLoading from '../../../components/ModalLoading';
import Modal from '../../../components/Modal/Modal';
import { Label } from '@material-ui/icons';

const dataInit = {
  id: '',
  titulo: '',
  instrucoes: '',
  dataInicio: moment(),
  dataFim: moment(),
  tipo: 0,
  tempo: 0,
  perfil: 0,
  categoria: 0,
  status: 0,
  obrigatorio: 0,
  parceiroAcaoExcluidos: [],
  parceiroAcaoAdicionar: [],
  perguntaAcaoExcluidos: [],
  perguntaAcaoAdicionar: [],
  textoCapaD: 'Escolha a Capa Desktop para o Treinamento',
  textoCapaM: 'Escolha a Capa Mobile para o Treinamento',
  textoCapaT: 'Escolha o arquivo de Treinamento',
  textoCapaA: 'Escolha o arquivo do Material de Apoio',
};

const perfilInit = {
  todos: false,
  responsavel: false,
  participante: false,
};
const categoriaInit = {
  Gerais: false,
  Onboarding: false,
  QualidadeVendas: false,
};

const tipoInit = {
  institucional: false,
  quiz: false,
};

const obrigatorioInit = {
  obrigatorio: true,
};

const configuracaoPremiacaoInit = {
  existe: 'sim',
  tipo: '0',
  link: '',
  acompanhante: false,
  quantidade: 0,
  descricao: '',
};

const AdicionarCampanha = () => {
  const [openModalConfirmation, setOpenModalConfirmation] =
    React.useState(false);
  const handleOpenModalConfirmation = () => {
    setOpenModalConfirmation(true);
  };
  const closeModalConfirmation = () => {
    setOpenModalConfirmation(false);
  };

  const [openModalComplete, setOpenModalComplete] = React.useState(false);
  const handleOpenModalComplete = () => {
    setOpenModalComplete(true);
  };
  const closeModalComplete = () => {
    setOpenModalComplete(false);
  };

  const dispatch = useDispatch();
  const showMsgW = (msg) => dispatch(showMsgWAction(msg));
  const showMsgE = (msg) => dispatch(showMsgEAction(msg));
  const showMsgS = (msg) => dispatch(showMsgSAction(msg));
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(false);
  const [logList, setLogList] = useState([]);
  const ref = useRef(null);

  const [buscar, setBuscar] = useState('');
  const [ativarBuscar, setAtivarBuscar] = useState(false);

  const history = useHistory();
  const [data, setData] = useState(dataInit);
  const [perfil, setPerfil] = useState(perfilInit);

  const [categoria, setCategoria] = useState(categoriaInit);

  const [tipo, setTipo] = useState(tipoInit);
  const [obrigatorio, setObrigatorio] = useState(obrigatorioInit);

  const [configuracaoPremiacao, setConfiguracaoPremiacao] = useState(
    configuracaoPremiacaoInit
  );

  const [regional, setRegional] = useState([]);
  const [regionalSelecionado, setRegionalSelecionado] = useState('todos');
  const [filial, setFilial] = useState([]);
  const [filialSelecionado, setFilialSelecionado] = useState('todos');
  const [parceiros, setParceiros] = useState([]);
  const [treinamentoId, setTreinamentoId] = useState([]);
  const [participantes, setParticipantes] = useState([]);
  const [parceiroSelecionado, setParceiroSelecionado] = useState('todos');
  const [nomeParceiroSelecionado, setNomeParceiroSelecionado] =
    useState('todos');
  const [parceiroAcaoPresentes, setParceiroTreinamentoPresentes] = useState([]);
  const [perguntaAcaoPresentes, setPerguntaTreinamentoPresentes] = useState([]);
  const [indicarErros, setIndicarErros] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  const [perguntaSelecionado, setPerguntaSelecionado] = useState('');
  const [ordemSelecionado, setOrdemSelecionado] = useState(
    'Geração automática...'
  );
  const [pontosSelecionado, setPontosSelecionado] = useState('');
  const [resposta1Selecionado, setResposta1Selecionado] = useState('');
  const [resposta2Selecionado, setResposta2Selecionado] = useState('');
  const [resposta3Selecionado, setResposta3Selecionado] = useState('');
  const [respostaCorretaSelecionado, setRespostaCorretaSelecionado] =
    useState('');
  const [permiteImportarBase, setpermiteImportarBase] = useState(false);

  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pageP, setPageP] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [maxPageP, setMaxPageP] = useState(1);

  const testStyle = {
    backgroundColor: { xs: 'secondary.light', sm: '#0000ff' },
  };

  useEffect(() => {
    const treinamento = new URLSearchParams(window.location.search).get(
      'treinamento'
    );
    if (treinamento && treinamento.trim() !== '') {
      setpermiteImportarBase(true);
    }
  }, []);

  const validarForm = () => {
    let valid = true;
    let msg = '';

    if (!data.titulo) {
      let msg = `Campo Título obrigatório`;
      valid = false;
      showMsgW(msg);
    }
    if (!data.dataInicio) {
      msg = 'Campo Data De é obrigatório\n';
      valid = false;
      showMsgW(msg);
    }
    if (!data.dataFim) {
      msg = 'Campo Data Para é obrigatório\n';
      valid = false;
      showMsgW(msg);
    }
    // && data.status != 2
    if (data.status != 0 && data.status != 1 && data.status != 2) {
      msg = 'Campo Status é obrigatório\n';
      valid = false;
      showMsgW(msg);
    }
    if (!data.ordem) {
      msg = 'Campo Ordem é obrigatório\n';
      valid = false;
      showMsgW(msg);
    }
    if (data.obrigatorio != true && data.obrigatorio != false) {
      msg = 'Campo Obrigatório é obrigatório\n';
      valid = false;
      showMsgW(msg);
    }
    if (data.tipo != 1 && data.tipo != 2) {
      msg = 'Campo Tipo é obrigatório\n';
      valid = false;
      showMsgW(msg);
    }
    if (!data.capaD && !data.capaDBlob) {
      msg = 'Arquivo de Capa Desktop é obrigatório\n';
      valid = false;
      showMsgW(msg);
    }
    if (!data.capaM && !data.capaMBlob) {
      msg = 'Arquivo de Capa Mobile é obrigatório\n';
      valid = false;
      showMsgW(msg);
    }
    if (!data.arquivoTreinamento && !data.arquivoTreinamentoBlob) {
      msg = 'Arquivo de treinamento é obrigatório\n';
      valid = false;
      showMsgW(msg);
    }

    if (!data.id && !Boolean(data.parceiroAcaoAdicionar.length)) {
      msg = 'Parceiro é obrigatório para treinamentos\n';
      valid = false;
      setIndicarErros(true);
      showMsgW(msg);
    }

    if (
      !data.id &&
      !Boolean(data.perguntaAcaoAdicionar.length) &&
      data.tipo == 2
    ) {
      msg = 'Pergunta é obrigatória para treinamentos\n';
      valid = false;
      setIndicarErros(true);
      showMsgW(msg);
    }

    return valid;
  };

  const findLojasParticipantesCadastradas = async () => {
    setModalLoading(true);
    try {
      const info = await getListaParceirosTreinamento(data.id, buscar);
      setAtivarBuscar(true);
      setParceiroTreinamentoPresentes(info.data);
      setMaxPage(data.maxPage);
    } catch (e) {
      showMsgE('Ocorreu um erro e não foi possível carregar dados');
    } finally {
      setModalLoading(false);
    }
  };

  const findLojasPerguntasCadastradas = async () => {
    setModalLoading(true);
    try {
      const info = await getListaPerguntasTreinamento(data.id, buscar);
      setAtivarBuscar(true);
      setPerguntaTreinamentoPresentes(info.data);
      setMaxPage(data.maxPage);
    } catch (e) {
      showMsgE('Ocorreu um erro e não foi possível carregar dados');
    } finally {
      setModalLoading(false);
    }
  };

  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const encerrar = async () => {
    setModalLoading(true);
    await postEncerrarCampanha(data.id);
    setModalLoading(false);
    history.push('/campanhas');
  };

  const getTreinamentoIfEdit = async (id) => {
    if (id) {
      setModalLoading(true);
      try {
        const info = await getTreinamentoWithId(id);

        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result;
        };

        setData({
          ...data,
          id: info.data.treinamentoId,
          titulo: info.data.titulo,
          instrucoes: info.data.instrucoes,
          dataInicio: moment(info.data.dataDe),
          dataFim: moment(info.data.dataAte),
          ordem: info.data.ordem,
          tipo: info.data.tipo,
          pontos: info.data.pontos,
          tempo: info.data.tempo,
          perfil: info.data.perfil,
          categoria: info.data.categoria,
          status: info.data.status,
          obrigatorio: info.data.obrigatorio,

          textoCapaD: info.data.capaD.fileDownloadName,
          textoCapaM: info.data.capaM.fileDownloadName,
          textoCapaT: info.data.arquivoTreinamentoNome,
          textoCapaA: info.data.materialApoio
            ? info.data.materialApoioNome
            : '',

          capaDBlob: b64toBlob(
            info.data.capaD.fileContents,
            info.data.capaD.contentType
          ),
          capaMBlob: b64toBlob(
            info.data.capaM.fileContents,
            info.data.capaM.contentType
          ),

          arquivoTreinamento: info.data.arquivoTreinamento,
          arquivoTreinamentoNome: info.data.arquivoTreinamentoNome,
          materialApoio: info.data.materialApoio,
          materialApoioNome: info.data.materialApoioNome,
        });

        if (info.data.tipo == 1) {
          changeTipo('institucional');
        } else {
          changeTipo('quiz');
        }

        switch (info.data.perfil) {
          case 0:
            info.todosPA = true;
            info.responsavelPA = true;
            info.participantePA = true;
            changePerfil('todos', true);
            break;
          case 2:
            info.todosPA = false;
            info.responsavelPA = true;
            info.participantePA = false;
            changePerfil('responsavel', true);
            break;
          case 3:
            info.todosPA = false;
            info.responsavelPA = false;
            info.participantePA = true;
            changePerfil('participante', true);
            break;
          default:
        }
        switch (info.data.categoria) {
          case 0:
            info.Gerais = true;
            info.Onboarding = false;
            info.QualidadeVendas = false;
            changeCategoria('Gerais', true);
            break;
          case 1:
            info.Gerais = false;
            info.Onboarding = true;
            info.QualidadeVendas = false;
            changeCategoria('Onboarding', true);
            break;
          case 2:
            info.Gerais = false;
            info.Onboarding = false;
            info.QualidadeVendas = true;
            changeCategoria('QualidadeVendas', true);
            break;
          default:
        }
        // {
        //     Gerais: false, - 0
        //     Onboarding: false,1
        //     QualidadeVendas: false 2
        // }

        pesquisar(info.data.treinamentoId);
        pesquisarPergunta(info.data.treinamentoId);

        setPerfil({
          todos: info.todosPA,
          responsavel: info.responsavelPA,
          participante: info.participantePA,
        });

        setTipo({
          institucional: info.institucionalPA,
          quiz: info.quizPA,
        });

        setConfiguracaoPremiacao({
          existe: 'sim',
          tipo: '1',
          link: '',
          acompanhante: false,
          quantidade: 0,
          descricao: '',
        });
      } catch (e) {
        showMsgW('Não foi possível carregar os dados');
      }
      setModalLoading(false);
    }
  };

  const adicionarParceiro = () => {
    const obj = {
      regional: regionalSelecionado,
      filial: filialSelecionado,
      nomeParceiro: nomeParceiroSelecionado,
      idParceiro: parceiroSelecionado,
    };
    //parceiroAcaoAdicionar
    setData({
      ...data,
      parceiroAcaoAdicionar: [...data.parceiroAcaoAdicionar, obj],
    });
  };

  const removerParceiro = (parceiro) => {
    let adicionados = [...data.parceiroAcaoAdicionar];
    let index = adicionados.findIndex((item) => item === parceiro);
    adicionados.splice(index, 1);
    setData({ ...data, parceiroAcaoAdicionar: adicionados });
  };
  const deletarParceiro = (parceiro, i) => {
    var novoData = {
      ...data,
      parceiroAcaoExcluidos: [...data.parceiroAcaoExcluidos, parceiro],
    };

    setData(novoData);

    var novoParceiroAcaoPresentes = [...parceiroAcaoPresentes];
    novoParceiroAcaoPresentes.splice(i, 1);
    setParceiroTreinamentoPresentes(novoParceiroAcaoPresentes);
  };

  const adicionarPergunta = () => {
    if (
      perguntaSelecionado == '' ||
      ordemSelecionado == '' ||
      //pontosSelecionado == "" ||
      resposta1Selecionado == '' ||
      resposta2Selecionado == '' ||
      resposta3Selecionado == '' ||
      respostaCorretaSelecionado == ''
    ) {
      showMsgW('Preencha todos os campos da pergunta.\n');
    } else {
      const obj = {
        pergunta: perguntaSelecionado,
        ordem: ordemSelecionado,
        pontos: pontosSelecionado,
        resposta1: resposta1Selecionado,
        resposta2: resposta2Selecionado,
        resposta3: resposta3Selecionado,
        respostaCorreta: respostaCorretaSelecionado,
      };

      setData({
        ...data,
        perguntaAcaoAdicionar: [...data.perguntaAcaoAdicionar, obj],
      });
      setPerguntaSelecionado('');
      setResposta1Selecionado('');
      setResposta2Selecionado('');
      setResposta3Selecionado('');
    }
  };

  const removerPergunta = (pergunta) => {
    let adicionados = [...data.perguntaAcaoAdicionar];
    let index = adicionados.findIndex((item) => item === pergunta);
    adicionados.splice(index, 1);
    setData({ ...data, perguntaAcaoAdicionar: adicionados });
  };
  const deletarPergunta = (pergunta, i) => {
    var novoData = {
      ...data,
      perguntaAcaoExcluidos: [...data.perguntaAcaoExcluidos, pergunta],
    };

    setData(novoData);

    var novoPerguntaAcaoPresentes = [...perguntaAcaoPresentes];
    novoPerguntaAcaoPresentes.splice(i, 1);
    setPerguntaTreinamentoPresentes(novoPerguntaAcaoPresentes);
  };

  const carregarRegional = async () => {
    const info = await getRegional();
 
    setRegional(info);
  };

  const carregarFilial = async () => {
    const info = await getFilial(regionalSelecionado);

    setFilial(info);
  };

  const carregarParceiro = async () => {
    const info = await getParceiros(regionalSelecionado, filialSelecionado);

    setParceiros(info);
  };

  const changePerfil = async (variavel, valor) => {
    if (variavel === 'todos') {
      setPerfil({
        todos: valor,
        responsavel: valor,
        participante: valor,
      });
    } else {
      setPerfil({
        ...perfil,
        [variavel]: valor,
      });
    }
  };
  const changeCategoria = (valor) => {
    setCategoria((prevCategoria) => {
      const updatedCategoria = { ...prevCategoria };

      // Desmarcar todos os outros checkboxes
      Object.keys(updatedCategoria).forEach((key) => {
        if (key !== valor) {
          updatedCategoria[key] = false;
        }
      });

      // Alternar o estado do checkbox selecionado
      updatedCategoria[valor] = !updatedCategoria[valor];

      return updatedCategoria;
    });
  };

  const changeTipo = async (variavel, valor) => {
    if (variavel === 'institucional') {
      setTipo({
        ...(data.tipo = 1),
      });
      document.getElementById('PR').style.display = 'none';
    } else {
      setTipo({
        ...(data.tipo = 2),
      });
      document.getElementById('PR').style.display = 'block';
    }
  };

  const changeObrigatorio = async (variavel, valor) => {
    if (variavel === 'Sim') {
      setObrigatorio({
        ...(data.obrigatorio = 1),
      });
    } else {
      setObrigatorio({
        ...(data.obrigatorio = 0),
      });
    }
  };

  const createSenderForm = () => {
    let formdata = new FormData();

    if (data.id !== '') {
      formdata.append('id', data.id);
    }
    formdata.append('titulo', data.titulo);
    formdata.append('instrucoes', data.instrucoes);
    formdata.append('DataDe', data.dataInicio.format('YYYY-MM-DD'));
    formdata.append('DataAte', data.dataFim.format('YYYY-MM-DD'));
    formdata.append('Status', data.status);
    formdata.append('Ordem', data.ordem);
    formdata.append('Tipo', data.tipo);
    formdata.append('Pontos', data.pontos);
    formdata.append('Tempo', data.tempo);
    formdata.append(
      'Perfil',
      perfil.todos == true
        ? 0
        : perfil.responsavel == true
        ? 2
        : perfil.participante == true
        ? 3
        : null
    );
    formdata.append(
      'Categoria',
      categoria.Gerais == true
        ? 0
        : categoria.Onboarding == true
        ? 1
        : categoria.QualidadeVendas == true
        ? 2
        : null
    );
    formdata.append('Obrigatorio', Boolean(data.obrigatorio));

    formdata.append(
      'CapaD',
      data.capaD == undefined
        ? data.capaDBlob
        : data.capaD.size == undefined
        ? data.capaDBlob
        : data.capaD
    );
    formdata.append('CapaDNome', data.textoCapaD);
    formdata.append(
      'CapaM',
      data.capaM == undefined
        ? data.capaMBlob
        : data.capaM.size == undefined
        ? data.capaMBlob
        : data.capaM
    );
    formdata.append('CapaMNome', data.textoCapaM);
    formdata.append(
      'MaterialApoio',
      data.materialApoio ? data.materialApoio : ''
    );
    formdata.append(
      'MaterialApoioNome',
      data.materialApoioNome ? data.materialApoioNome : ''
    );
    formdata.append('ArquivoTreinamento', data.arquivoTreinamento);
    formdata.append('ArquivoTreinamentoNome', data.arquivoTreinamentoNome);

    for (let i = 0; i < data.parceiroAcaoAdicionar.length; i++) {
      if (data.parceiroAcaoAdicionar[i].idParceiro !== 'todos')
        formdata.append(
          `TreinamentoParceiros[${i}].parceiroId`,
          data.parceiroAcaoAdicionar[i].idParceiro
        );

      if (data.parceiroAcaoAdicionar[i].regional !== 'todos')
        formdata.append(
          `TreinamentoParceiros[${i}].Regional`,
          data.parceiroAcaoAdicionar[i].regional
        );

      if (data.parceiroAcaoAdicionar[i].filial !== 'todos')
        formdata.append(
          `TreinamentoParceiros[${i}].Filial`,
          data.parceiroAcaoAdicionar[i].filial
        );

      if (
        data.parceiroAcaoAdicionar[i].idParceiro == 'todos' &&
        data.parceiroAcaoAdicionar[i].regional == 'todos' &&
        data.parceiroAcaoAdicionar[i].filial == 'todos'
      )
        formdata.append(
          `TreinamentoParceiros[${i}].parceiroId`,
          '00000000-0000-0000-0000-000000000000'
        );

      formdata.append(`TreinamentoParceiros[${i}].Contador`, i);
    }
    for (let i = 0; i < parceiroAcaoPresentes.length; i++) {
      formdata.append(
        `Parceiros[${i + parceiroAcaoPresentes.length}].parceiroId`,
        parceiroAcaoPresentes[i].idParceiro
      );

      formdata.append(
        `Parceiros[${i + parceiroAcaoPresentes.length}].Regional`,
        parceiroAcaoPresentes[i].regional
      );

      formdata.append(
        `Parceiros[${i + parceiroAcaoPresentes.length}].Filial`,
        parceiroAcaoPresentes[i].filial
      );
    }
    for (let i = 0; i < data.parceiroAcaoExcluidos.length; i++) {
 

      if (data.parceiroAcaoExcluidos[i].idParceiro != null)
        formdata.append(
          `TreinamentoParceirosExcluidos[${i}].parceiroId`,
          data.parceiroAcaoExcluidos[i].idParceiro
        );

      if (data.parceiroAcaoExcluidos[i].regional != 'todos')
        formdata.append(
          `TreinamentoParceirosExcluidos[${i}].Regional`,
          data.parceiroAcaoExcluidos[i].regional
        );

      if (data.parceiroAcaoExcluidos[i].filial != 'todos')
        formdata.append(
          `TreinamentoParceirosExcluidos[${i}].Filial`,
          data.parceiroAcaoExcluidos[i].filial
        );

      if (
        data.parceiroAcaoExcluidos[i].idParceiro == null &&
        data.parceiroAcaoExcluidos[i].regional == 'todos' &&
        data.parceiroAcaoExcluidos[i].filial == 'todos'
      )
        formdata.append(
          `TreinamentoParceirosExcluidos[${i}].parceiroId`,
          '00000000-0000-0000-0000-000000000000'
        );

      formdata.append(`TreinamentoParceirosExcluidos[${i}].Contador`, i);
    }
    for (let i = 0; i < data.perguntaAcaoAdicionar.length; i++) {
      formdata.append(`Perguntas[${i}].ordem`, 0);
      formdata.append(
        `Perguntas[${i}].pergunta`,
        data.perguntaAcaoAdicionar[i].pergunta
      );
      formdata.append(`Perguntas[${i}].pontos`, 0);
      formdata.append(
        `Perguntas[${i}].resposta1`,
        data.perguntaAcaoAdicionar[i].resposta1
      );
      formdata.append(
        `Perguntas[${i}].resposta1Correta`,
        data.perguntaAcaoAdicionar[i].respostaCorreta == 'Resposta 1'
          ? true
          : false
      );
      formdata.append(
        `Perguntas[${i}].resposta2`,
        data.perguntaAcaoAdicionar[i].resposta2
      );
      formdata.append(
        `Perguntas[${i}].resposta2Correta`,
        data.perguntaAcaoAdicionar[i].respostaCorreta == 'Resposta 2'
          ? true
          : false
      );
      formdata.append(
        `Perguntas[${i}].resposta3`,
        data.perguntaAcaoAdicionar[i].resposta3
      );
      formdata.append(
        `Perguntas[${i}].resposta3Correta`,
        data.perguntaAcaoAdicionar[i].respostaCorreta == 'Resposta 3'
          ? true
          : false
      );
    }
    for (let i = 0; i < perguntaAcaoPresentes.length; i++) {
      formdata.append(
        `Perguntas[${i + data.perguntaAcaoAdicionar.length}].ordem`,
        perguntaAcaoPresentes[i].ordem
      );
      formdata.append(
        `Perguntas[${i + data.perguntaAcaoAdicionar.length}].pergunta`,
        perguntaAcaoPresentes[i].pergunta
      );
      formdata.append(
        `Perguntas[${i + data.perguntaAcaoAdicionar.length}].pontos`,
        perguntaAcaoPresentes[i].pontos
      );
      formdata.append(
        `Perguntas[${i + data.perguntaAcaoAdicionar.length}].resposta1`,
        perguntaAcaoPresentes[i].resposta1
      );
      formdata.append(
        `Perguntas[${i + data.perguntaAcaoAdicionar.length}].resposta1Correta`,
        perguntaAcaoPresentes[i].respostaCorreta == 'Resposta 1' ? true : false
      );
      formdata.append(
        `Perguntas[${i + data.perguntaAcaoAdicionar.length}].resposta2`,
        perguntaAcaoPresentes[i].resposta2
      );
      formdata.append(
        `Perguntas[${i + data.perguntaAcaoAdicionar.length}].resposta2Correta`,
        perguntaAcaoPresentes[i].respostaCorreta == 'Resposta 2' ? true : false
      );
      formdata.append(
        `Perguntas[${i + data.perguntaAcaoAdicionar.length}].resposta3`,
        perguntaAcaoPresentes[i].resposta3
      );
      formdata.append(
        `Perguntas[${i + data.perguntaAcaoAdicionar.length}].resposta3Correta`,
        perguntaAcaoPresentes[i].respostaCorreta == 'Resposta 3' ? true : false
      );
    }

    return formdata;
  };

  const enviar = async () => {
    setIndicarErros(false);
    if (validarForm()) {
      let formdata = createSenderForm();
      if (data.id !== '') {
        setModalLoading(true);
   
        await editTreinamento(formdata, data.id)
          .then((res) => {
            if (res.data) {
              showMsgS('Treinamento alterados com sucesso!');
              setTimeout(() => {
                history.push('/treinamentos');
              }, 2000);
            } else {
              showMsgE(res.errors ? res.errors.message : 'Erro');
            }
          })
          .catch((message) => {
            showMsgW(
              message.response.data.message.length
                ? message.response.data.message
                : 'Ocorreu um erro ao salvar os dados'
            );
          });
        setModalLoading(false);
      } else {
        setModalLoading(true);
        try {
          let info = await saveTreinamento(formdata);
          showMsgS('Treinamento salvos com sucesso!');
          setTimeout(() => {
            history.push('/treinamentos');
          }, 2000);
        } catch (e) {
          showMsgE('Ocorreu um erro ao salvar os dados');
        }
        setModalLoading(false);
      }
    }
  };

  const pesquisar = async (id) => {
    const info = await getListaParceirosTreinamento(id, search, page);
    setParceiroTreinamentoPresentes(info.data);
    setMaxPage(info.maxPage);
  };

  const pesquisarPergunta = async (id) => {
    const info = await getListaPerguntasTreinamento(id, search, page);
    setPerguntaTreinamentoPresentes(info.data);
    setMaxPage(info.maxPage);
  };

  const onFileChange = (event) => {
    let file;
    if (event.target.files && event.target.files[0]) {
      file = event.target.files[0];
      if (
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        setDados(file);
      } else {
        showMsgE('Favor escolher arquivos .xlsx');
      }
    }
  };

  const callFileInput = () => {
    ref.current.click();
  };

  const getLogList = async () => {
    const info = await getParceiroLogImportacao(page);
    setLogList(info.data.data);
    setMaxPage(info.data.maxPage);
  };

  useDebounce(search, 750, () => {
    pesquisar(data.id);
  });

  useEffect(() => {
    if (!perfil.todos && perfil.responsavel && perfil.participante) {
      setPerfil({
        ...perfil,
        todos: true,
      });
    } else if (perfil.todos && (!perfil.responsavel || !perfil.participante)) {
      setPerfil({
        ...perfil,
        todos: false,
      });
    }
  }, [perfil]);

  useEffect(() => {
    carregarRegional();
    const treinamento = new URLSearchParams(history.location.search).get(
      'treinamento'
    );
    setTreinamentoId(treinamento);
    getTreinamentoIfEdit(treinamento);
  }, []);

  useEffect(() => {
    if (regionalSelecionado) {
      carregarFilial();
    }
  }, [regionalSelecionado]);

  useEffect(() => {
    if (filialSelecionado) {
      carregarParceiro();
    }
  }, [filialSelecionado]);

  useEffect(() => {
    if (data.id) {
      pesquisar(data.id);
    }
  }, [page]);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const user = useGetUser();

  return (
    <>
      {user.perfilAcesso === 'Master' && (
        <>
          <div className={styles.wrapper}>
            <div className={styles.title}>
              Novo Treinamento
              <button
                className={styles.backButton}
                onClick={() => {
                  history.goBack();
                }}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
            </div>
            <div className={styles.blueBackground}>
              <div className={styles.content}>
                <div
                  className={styles.card}
                  style={{ padding: '16px 16px 6px 16px' }}
                >
                  <FormControl className={styles.nome}>
                    <TextField
                      type="text"
                      size="small"
                      onChange={(e) => {
                        setData({ ...data, titulo: e.target.value });
                      }}
                      label="Título"
                      value={data.titulo}
                      variant="filled"
                      error={indicarErros && !data.titulo ? true : false}
                      className="customFilledInput"
                    />
                  </FormControl>
                  <FormControl className={styles.data}>
                    <MuiPickersUtilsProvider
                      locale="pt-br"
                      libInstance={moment}
                      utils={MomentUtils}
                    >
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        label="Data De"
                        format="DD/MM/yyyy"
                        value={data.dataInicio}
                        InputAdornmentProps={{ position: 'start' }}
                        onChange={(novaData) => {
                          setData({ ...data, dataInicio: novaData });
                        }}
                        className="customFilledInput"
                        error={indicarErros && !data.dataInicio ? true : false}
                        invalidDateMessage="Data em formato inválido."
                        maxDateMessage="Data não deve ser maior que a data máxima."
                        minDateMessage="Data não deve ser menor que a data mínima."
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                  <FormControl className={styles.data}>
                    <MuiPickersUtilsProvider
                      locale="pt-br"
                      libInstance={moment}
                      utils={MomentUtils}
                    >
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        label="Data Até"
                        format="DD/MM/yyyy"
                        value={data.dataFim}
                        InputAdornmentProps={{ position: 'start' }}
                        onChange={(novaData) => {
                          setData({ ...data, dataFim: novaData });
                        }}
                        className="customFilledInput"
                        error={indicarErros && !data.dataFim ? true : false}
                        invalidDateMessage="Data em formato inválido."
                        maxDateMessage="Data não deve ser maior que a data máxima."
                        minDateMessage="Data não deve ser menor que a data mínima."
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                  <FormControl className={styles.dezporc}>
                    <InputLabel
                      id="select-status-label"
                      className={styles.label}
                    >
                      Status
                    </InputLabel>
                    <Select
                      labelId="select-status-label"
                      label="Status"
                      onChange={(e) => {
                        setData({ ...data, status: e.target.value });
                      }}
                      value={data.status}
                      variant="filled"
                      className="customFilledInput"
                    >
                      <MenuItem value={1}>Ativo</MenuItem>
                      <MenuItem value={0}>Inativo</MenuItem>
                      <MenuItem value={2}>Rascunho</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl className={styles.dezporc}>
                    <TextField
                      type="text"
                      size="small"
                      onChange={(e) => {
                        setData({ ...data, ordem: e.target.value });
                      }}
                      label="Ordem de Exibição"
                      value={data.ordem}
                      variant="filled"
                      className={`customFilledInput ${styles.padding10}`}
                      error={indicarErros && !data.ordem ? true : false}
                    />
                  </FormControl>
                  <FormControl className={styles.dezporc}>
                    <TextField
                      type="text"
                      size="small"
                      onChange={(e) => {
                        setData({ ...data, pontos: e.target.value });
                      }}
                      label="Pontos"
                      value={data.pontos}
                      variant="filled"
                      className={`customFilledInput ${styles.padding10}`}
                      error={indicarErros && !data.pontos ? true : false}
                    />
                  </FormControl>
                  <FormControl className={styles.seteporc}>
                    <InputLabel
                      id="select-perfil-label"
                      className={styles.label}
                    >
                      <div className={styles.subtitleConfiguracao}>
                        Obrigatório?
                      </div>
                    </InputLabel>
                  </FormControl>

                  <FormControl className={styles.dezporc}>
                    <RadioGroup aria-label="obrigatorio" defaultValue="sim">
                      <FormControlLabel
                        value="1"
                        checked={data.obrigatorio}
                        control={<Radio style={{ color: '#5CCBE1' }} />}
                        label="Sim"
                        className={styles.radioOptions}
                        onChange={(e) => {
                          changeObrigatorio('Sim', e.target.checked);
                        }}
                      />
                      <FormControlLabel
                        value="0"
                        checked={!data.obrigatorio}
                        control={<Radio style={{ color: '#5CCBE1' }} />}
                        label="Não"
                        className={styles.radioOptions}
                        onChange={(e) => {
                          changeObrigatorio('Não', e.target.checked);
                        }}
                      />
                    </RadioGroup>
                  </FormControl>
                  <FormControl className={styles.trezporc}>
                    <InputLabel
                      id="select-perfil-label"
                      className={styles.label}
                    >
                      <div className={styles.subtitleConfiguracao}>Perfil</div>
                    </InputLabel>
                  </FormControl>
                  <FormControl className={styles.dezporc}>
                    <FormControlLabel
                      value="todos"
                      control={
                        <Checkbox
                          style={{ color: '#5CCBE1' }}
                          checked={perfil.todos}
                          onChange={(e) => {
                            changePerfil('todos', e.target.checked);
                          }}
                        />
                      }
                      label="Todos"
                      className={styles.radioOptions}
                    />
                    <FormControlLabel
                      value="responsavel"
                      control={
                        <Checkbox
                          style={{ color: '#5CCBE1' }}
                          checked={perfil.responsavel}
                          onChange={(e) => {
                            changePerfil('responsavel', e.target.checked);
                          }}
                        />
                      }
                      label="Responsável"
                      className={styles.radioOptions}
                    />
                    <FormControlLabel
                      value="participante"
                      control={
                        <Checkbox
                          style={{ color: '#5CCBE1' }}
                          checked={perfil.participante}
                          onChange={(e) => {
                            changePerfil('participante', e.target.checked);
                          }}
                        />
                      }
                      label="Participante"
                      className={styles.radioOptions}
                    />
                  </FormControl>
                  <FormControl className={styles.trezporc}>
                    <InputLabel id="select-tipo-label" className={styles.label}>
                      <div className={styles.subtitleConfiguracao}>Tipo</div>
                    </InputLabel>
                  </FormControl>
                  <FormControl className={styles.dezporc}>
                    <RadioGroup aria-label="tipo">
                      <FormControlLabel
                        value="1"
                        checked={data.tipo == 1}
                        control={<Radio style={{ color: '#5CCBE1' }} />}
                        label="Institucional"
                        className={styles.radioOptions}
                        onChange={(e) => {
                          changeTipo('institucional', e.target.checked);
                        }}
                      />
                      <FormControlLabel
                        value="2"
                        checked={data.tipo == 2}
                        control={<Radio style={{ color: '#5CCBE1' }} />}
                        label="Quiz"
                        className={styles.radioOptions}
                        onChange={(e) => {
                          changeTipo('quiz', e.target.checked);
                        }}
                      />
                    </RadioGroup>
                  </FormControl>
                  <FormControl className={styles.half}>
                    <div className={styles.subtitle}>
                      Instruções do Treinamento
                    </div>
                    <TextareaAutosize
                      type="text"
                      size="small"
                      minRows={5}
                      placeholder="Descreva as instruções do treinamento como:
                                        Regras em geral, pontuações ou demais explicações."
                      onChange={(e) => {
                        setData({ ...data, instrucoes: e.target.value });
                      }}
                      label="Instrucoes"
                      value={data.instrucoes != 'null' ? data.instrucoes : ''}
                      variant="filled"
                      error={indicarErros && !data.instrucoes ? true : false}
                      className="customFilledInput"
                    />
                  </FormControl>
                  <FormControl className={styles.quinzeporc}>
                    <div className={styles.subtitle}>
                      Tempo de duração leitura ou apresentação
                    </div>
                    <TextField
                      type="text"
                      size="small"
                      onChange={(e) => {
                        setData({ ...data, tempo: e.target.value });
                      }}
                      label="Tempo em minutos."
                      value={data.tempo}
                      variant="filled"
                      className="customFilledInput"
                      error={indicarErros && !data.tempo ? true : false}
                    />
                  </FormControl>

                  <FormControl className={styles.trezporc}>
                    <InputLabel id="select-perfil-label">
                      <div className={styles.subtitleConfiguracao}>
                        Categoria
                      </div>
                    </InputLabel>
                  </FormControl>

                  <FormControl className={styles.dezporc}>
                    <FormControlLabel
                      value="1"
                      control={
                        <Checkbox
                          style={{ color: '#5CCBE1' }}
                          checked={categoria.Onboarding}
                          onChange={(e) => {
                            changeCategoria('Onboarding', e.target.checked);
                          }}
                        />
                      }
                      label="Onboarding"
                      className={styles.radioOptions}
                      style={{ whiteSpace: 'nowrap' }} // Add this style to prevent text wrapping
                    />

                    <FormControlLabel
                      value="2"
                      control={
                        <Checkbox
                          style={{ color: '#5CCBE1' }}
                          checked={categoria.QualidadeVendas}
                          onChange={(e) => {
                            changeCategoria(
                              'QualidadeVendas',
                              e.target.checked
                            );
                          }}
                        />
                      }
                      label="Programa de Qualidade de Vendas"
                      className={styles.radioOptions}
                      style={{ whiteSpace: 'nowrap' }} // Add this style to prevent text wrapping
                    />

                    <FormControlLabel
                      value="0"
                      control={
                        <Checkbox
                          style={{ color: '#5CCBE1' }}
                          checked={categoria.Gerais}
                          onChange={(e) => {
                            changeCategoria('Gerais', e.target.checked);
                          }}
                        />
                      }
                      label="Gerais"
                      className={styles.radioOptions}
                      style={{ whiteSpace: 'nowrap' }} // Add this style to prevent text wrapping
                    />
                  </FormControl>
                </div>
              </div>
            </div>
            <div className={styles.blueBackground}>
              <div className={styles.content}>
                <div className={styles.card}>
                  <div className={styles.subtitle}>Capa do Treinamento</div>
                  <div className={styles.divImageList}>
                    <ButtonsImagesCampain
                      texto={data.textoCapaD}
                      width="1200"
                      height="600"
                      widthMM="317.5"
                      heightMM="158.75"
                      image={data.capaD}
                      blob={data.capaDBlob}
                      changeImage={(file) => {
                        setData({ ...data, capaD: file });
                      }}
                      error={
                        indicarErros && !data.capaD && !data.capaDpBlob
                          ? true
                          : false
                      }
                    />
                    <ButtonsImagesCampain
                      texto={data.textoCapaM}
                      width="400"
                      height="400"
                      widthMM="132.29"
                      heightMM="132.29"
                      image={data.capaM}
                      blob={data.capaMBlob}
                      changeImage={(file) => {
                        setData({ ...data, capaM: file });
                      }}
                      error={
                        indicarErros && !data.capaM && !data.capaMpBlob
                          ? true
                          : false
                      }
                    />
                  </div>
                </div>
              </div>
              <div className={styles.blueBackground}>
                <div className={styles.content}>
                  <div className={styles.card}>
                    <div className={styles.subtitle}>
                      Treinamento e Material de Apoio
                    </div>
                    <div className={styles.divImageList}>
                      <div className={styles.subtitle}>
                        <a href={data.arquivoTreinamento} target="blank">
                          {data.arquivoTreinamentoNome
                            ? data.arquivoTreinamentoNome
                            : data.textoCapaT}
                        </a>
                        <ButtonsAnexoTreinamento
                          tamanho="20 Mb"
                          image={data.arquivoTreinamento}
                          blob={data.arquivoTreinamentoBlob}
                          changeImage={(file, nome) => {
                            setData({
                              ...data,
                              arquivoTreinamento: file,
                              arquivoTreinamentoNome: nome,
                            });
                          }}
                          modalLoading={setModalLoading}
                          error={
                            indicarErros &&
                            !data.arquivoTreinamento &&
                            !data.arquivoTreinamentoBlob
                              ? true
                              : false
                          }
                        />
                      </div>
                      <div className={styles.subtitle}>
                        <a href={data.materialApoio} target="blank">
                          {data.materialApoioNome
                            ? data.materialApoioNome
                            : data.textoCapaA}
                        </a>
                        <ButtonsAnexoTreinamento
                          tamanho="20 Mb"
                          image={data.materialApoio}
                          blob={data.materialApoioBlob}
                          changeImage={(file, nome) => {
                            setData({
                              ...data,
                              materialApoio: file,
                              materialApoioNome: nome,
                            });
                          }}
                          modalLoading={setModalLoading}
                          error={
                            indicarErros &&
                            !data.materialApoio &&
                            !data.materialApoioBlob
                              ? true
                              : false
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.blueBackground}>
              <div className={styles.content}>
                <div className={styles.card}>
                  <div className={styles.subtitle}>Configuração</div>
                  <div>
                    <div className={styles.subtitleConfiguracao}>
                      Lojas participantes
                    </div>
                    <FormControl className={styles.selects}>
                      <InputLabel
                        id="select-status-label"
                        className={styles.selectsLabel}
                      >
                        Regional
                      </InputLabel>
                      <Select
                        labelId="select-status-label"
                        label="Status"
                        onChange={(e) => {
                          setRegionalSelecionado(e.target.value);
                        }}
                        value={regionalSelecionado}
                        variant="filled"
                        className="customFilledInput"
                      >
                        <MenuItem value="todos">Todos</MenuItem>
                        {regional.map((regiao) => {
                          return (
                            <MenuItem value={regiao} key={regiao}>
                              {regiao}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl className={styles.selects}>
                      <InputLabel
                        id="select-status-label"
                        className={styles.selectsLabel}
                      >
                        Filial
                      </InputLabel>
                      <Select
                        labelId="select-status-label"
                        label="Status"
                        onChange={(e) => {
                          setFilialSelecionado(e.target.value);
                        }}
                        value={filialSelecionado}
                        variant="filled"
                        className="customFilledInput"
                      >
                        <MenuItem value="todos">Todos</MenuItem>
                        {filial.map((info) => {
                          return (
                            <MenuItem value={info} key={info}>
                              {info}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl className={styles.selects}>
                      <InputLabel
                        id="select-status-label"
                        className={styles.selectsLabel}
                      >
                        Loja
                      </InputLabel>
                      <Select
                        labelId="select-status-label"
                        label="Status"
                        onChange={(e) => {
                          if (e.target.value !== 'todos') {
                            setParceiroSelecionado(e.target.value);
                            let parceiro = parceiros.find(
                              (p) => p.idParceiro === e.target.value
                            );
                            setNomeParceiroSelecionado(parceiro.nomeParceiro);
                          } else {
                            setParceiroSelecionado(e.target.value);
                            setNomeParceiroSelecionado(e.target.value);
                          }
                        }}
                        value={parceiroSelecionado}
                        variant="filled"
                        className="customFilledInput"
                      >
                        <MenuItem value="todos">Todos</MenuItem>
                        {parceiros.map((parceiro) => {
                          return (
                            <MenuItem
                              value={parceiro.idParceiro}
                              key={parceiro.nomeParceiro}
                            >
                              {parceiro.nomeParceiro}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <div className={styles.divImageList}>
                      <button
                        className={styles.salvar}
                        onClick={adicionarParceiro}
                      >
                        Adicionar
                      </button>
                    </div>
                    <div>
                      <br />
                      <div className={styles.subtitle}>Upload de arquivo</div>
                      <div>
                        Para adicionar participantes em massa, baixe o arquivo
                        modelo, adicione a planilha preenchida e em seguida
                        clique em processar planilha
                      </div>
                      <br />
                      {/* Claudinei  */}
                      <div
                        className={styles.divImageList}
                        id="divUploadArquivo"
                      >
                        {permiteImportarBase ? (
                          <button
                            className={`btnInvert ${styles.btImportarParticipantes}`}
                            onClick={() => {
                              history.push(
                                '/treinamentos/importar?treinamento=' +
                                  treinamentoId
                              );
                            }}
                            // disabled={!permiteImportarBase}
                          >
                            Importar base de parceiros
                          </button>
                        ) : null}
                      </div>
                    </div>
                    <div className={styles.subtitleConfiguracao}>
                      Lojas participantes - adicionar
                    </div>
                    <div className={styles.addLojasWrapper}>
                      {Boolean(data.parceiroAcaoAdicionar.length) ? (
                        data.parceiroAcaoAdicionar.map((loja) => {
                          return (
                            <ParceiroCard
                              parceiro={loja}
                              key={loja.idLoja}
                              remover={removerParceiro}
                            />
                          );
                        })
                      ) : (
                        <div>Nenhum parceiro nesta lista</div>
                      )}
                    </div>
                    {data.id && (
                      <>
                        <div className={styles.subtitleConfiguracao}>
                          Lojas participantes - cadastradas
                        </div>
                        {Boolean(parceiroAcaoPresentes.length) ? (
                          <div className={styles.searchWrapper}>
                            <TextField
                              type="text"
                              size="small"
                              onChange={(e) => {
                                setBuscar(e.target.value);
                              }}
                              label="Faça sua busca"
                              value={buscar}
                              variant="filled"
                              multiline
                              className="customFilledInput"
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  findLojasParticipantesCadastradas();
                                  e.preventDefault();
                                }
                              }}
                              InputProps={{
                                endAdornment: (
                                  <button
                                    onClick={findLojasParticipantesCadastradas}
                                    className={styles.searchButton}
                                  >
                                    <FontAwesomeIcon icon={faSearch} />
                                  </button>
                                ),
                              }}
                            />
                          </div>
                        ) : (
                          ''
                        )}

                        <div className={styles.addLojasWrapper}>
                          {Boolean(parceiroAcaoPresentes.length) ? (
                            parceiroAcaoPresentes.map((loja, i) => {
                              return (
                                <ParceiroCard
                                  parceiro={loja}
                                  key={loja.idLoja}
                                  remover={() => deletarParceiro(loja, i)}
                                />
                              );
                            })
                          ) : (
                            <div>Nenhum parceiro nesta lista</div>
                          )}
                        </div>
                        {maxPage > 1 && (
                          <Paginacao
                            maxPage={maxPage}
                            page={page}
                            setPage={setPage}
                          />
                        )}
                      </>
                    )}
                    <div className={styles.subtitleConfiguracao}>
                      Lojas participantes - remover
                    </div>
                    <div className={styles.addLojasWrapper}>
                      {Boolean(data.parceiroAcaoExcluidos.length) ? (
                        data?.parceiroAcaoExcluidos?.map((loja) => {
                          return (
                            <ParceiroCard parceiro={loja} key={loja.idLoja} />
                          );
                        })
                      ) : (
                        <div>Nenhum parceiro nesta lista</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.content} ID="PR">
              <div className={styles.card}>
                <div className={styles.subtitle}>Perguntas e Respostas</div>
                <div>
                  <FormControl className={styles.nome}>
                    <TextField
                      type="text"
                      size="small"
                      onChange={(e) => {
                        setPerguntaSelecionado(e.target.value);
                      }}
                      label="Pergunta"
                      value={perguntaSelecionado}
                      variant="filled"
                      id="Pergunta"
                      error={indicarErros && !data.pergunta ? true : false}
                      className="customFilledInput"
                    />
                  </FormControl>
                  <FormControl>
                    <RadioGroup aria-label="Resposta">
                      <table>
                        <tr>
                          <td className={styles.cincoporc}>
                            <FormControlLabel
                              value="respostaCorreta1Selecionado"
                              control={
                                <Radio
                                  style={{ color: '#5CCBE1' }}
                                  onChange={(e) => {
                                    setRespostaCorretaSelecionado('Resposta 1');
                                  }}
                                />
                              }
                              className={styles.radioOptionsText}
                            />
                          </td>
                          <td>
                            <TextField
                              type="text"
                              size="small"
                              onChange={(e) => {
                                setResposta1Selecionado(e.target.value);
                              }}
                              label="Resposta 1"
                              value={resposta1Selecionado}
                              variant="filled"
                              className="customFilledInput"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.cincoporc}>
                            <FormControlLabel
                              value="respostaCorreta2Selecionado"
                              control={
                                <Radio
                                  style={{ color: '#5CCBE1' }}
                                  onChange={(e) => {
                                    setRespostaCorretaSelecionado('Resposta 2');
                                  }}
                                />
                              }
                              className={styles.radioOptionsText}
                            />
                          </td>
                          <td>
                            <TextField
                              type="text"
                              size="small"
                              onChange={(e) => {
                                setResposta2Selecionado(e.target.value);
                              }}
                              label="Resposta 2"
                              value={resposta2Selecionado}
                              variant="filled"
                              className="customFilledInput"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.cincoporc}>
                            <FormControlLabel
                              value="respostaCorreta3Selecionado"
                              control={
                                <Radio
                                  style={{ color: '#5CCBE1' }}
                                  onChange={(e) => {
                                    setRespostaCorretaSelecionado('Resposta 3');
                                  }}
                                />
                              }
                              className={styles.radioOptionsText}
                            />
                          </td>
                          <td>
                            <TextField
                              type="text"
                              size="small"
                              onChange={(e) => {
                                setResposta3Selecionado(e.target.value);
                              }}
                              label="Resposta 3"
                              value={resposta3Selecionado}
                              variant="filled"
                              className="customFilledInput"
                            />
                          </td>
                        </tr>
                      </table>
                    </RadioGroup>
                  </FormControl>
                  <div className={styles.divImageList}>
                    <button
                      className={styles.salvar}
                      onClick={adicionarPergunta}
                    >
                      Adicionar
                    </button>
                  </div>
                  <div className={styles.subtitleConfiguracao}>
                    Perguntas e Respostas - adicionar
                  </div>
                  <div className={styles.addLojasWrapper}>
                    {Boolean(data.perguntaAcaoAdicionar.length) ? (
                      data.perguntaAcaoAdicionar.map((perg) => {
                        return (
                          <PerguntaCard
                            pergunta={perg}
                            key={perg.idperg}
                            remover={removerPergunta}
                          />
                        );
                      })
                    ) : (
                      <div>Nenhuma Pergunta nesta lista</div>
                    )}
                  </div>
                  {data.id && (
                    <>
                      <div className={styles.subtitleConfiguracao}>
                        Perguntas e Respostas - cadastradas
                      </div>
                      {Boolean(perguntaAcaoPresentes.length) ? (
                        <div className={styles.searchWrapper}>
                          <TextField
                            type="text"
                            size="small"
                            onChange={(e) => {
                              setBuscar(e.target.value);
                            }}
                            label="Faça sua busca"
                            value={buscar}
                            variant="filled"
                            multiline
                            className="customFilledInput"
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                findLojasPerguntasCadastradas();
                                e.preventDefault();
                              }
                            }}
                            InputProps={{
                              endAdornment: (
                                <button
                                  onClick={findLojasPerguntasCadastradas}
                                  className={styles.searchButton}
                                >
                                  <FontAwesomeIcon icon={faSearch} />
                                </button>
                              ),
                            }}
                          />
                        </div>
                      ) : (
                        ''
                      )}

                      <div className={styles.addLojasWrapper}>
                        {Boolean(perguntaAcaoPresentes.length) ? (
                          perguntaAcaoPresentes.map((perg, i) => {
                            return (
                              <PerguntaCard
                                pergunta={perg}
                                key={perg.idPerg}
                                remover={() => deletarPergunta(perg, i)}
                              />
                            );
                          })
                        ) : (
                          <div>Nenhum Pergunta nesta lista</div>
                        )}
                      </div>
                      {maxPageP > 1 && (
                        <Paginacao
                          maxPage={maxPageP}
                          page={pageP}
                          setPage={setPageP}
                        />
                      )}
                    </>
                  )}
                  <div className={styles.subtitleConfiguracao}>
                    Perguntas e Respostas - remover
                  </div>
                  <div className={styles.addLojasWrapper}>
                    {Boolean(data.perguntaAcaoExcluidos.length) ? (
                      data?.perguntaAcaoExcluidos?.map((perg) => {
                        return (
                          <PerguntaCard pergunta={perg} key={perg.idPerg} />
                        );
                      })
                    ) : (
                      <div>Nenhum Pergunta nesta lista</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.blueBackground}>
              <div className={styles.content}>
                <div className={styles.card}>
                  <div className={styles.divImageList}>
                    <button className={styles.salvar} onClick={enviar}>
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalLoading open={modalLoading} size="lg" />
          <Modal
            open={openModalComplete}
            close={closeModalComplete}
            size={'sm'}
          >
            <div className="pad20">
              <div className="row">
                <div className="col-sm-12">
                  <Paticipantes participantes={participantes} />
                </div>

                <div className="col-sm-12 text-center">
                  <button
                    onClick={closeModalComplete}
                    className="btn btn-outline-info btn-lg mt20 padL40 padR40 mr10"
                  >
                    Voltar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default AdicionarCampanha;
